import { useI18n } from "@/i18n/I18nProvider";
import type { FAQ as FAQType } from "@/lib/types";

export function FAQ({ items, title }: { items: FAQType[]; title?: string }) {
  const { t, lang } = useI18n();
  return (
    <section className="space-y-3">
      <h2 className="text-2xl font-bold">{title ?? t("review.faq")}</h2>
      <div className="space-y-2">
        {items.map((item, i) => (
          <details
            key={i}
            className="card group p-4 open:shadow-md"
          >
            <summary className="flex cursor-pointer list-none items-center justify-between gap-4 text-base font-semibold text-ink-900">
              {lang === "sv" ? item.question_sv : item.question_en}
              <span aria-hidden className="text-ink-400 transition group-open:rotate-180">
                ▾
              </span>
            </summary>
            <p className="mt-2 text-sm text-ink-700">
              {lang === "sv" ? item.answer_sv : item.answer_en}
            </p>
          </details>
        ))}
      </div>
    </section>
  );
}

export function buildFAQSchema(items: FAQType[], lang: "sv" | "en") {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((i) => ({
      "@type": "Question",
      name: lang === "sv" ? i.question_sv : i.question_en,
      acceptedAnswer: {
        "@type": "Answer",
        text: lang === "sv" ? i.answer_sv : i.answer_en,
      },
    })),
  };
}
